module.exports = __webpack_public_path__ + "img/4.f35bdeb8.png";